import React, { useState, useEffect,useRef } from 'react';
import './FAQ.css';
import Wave from '../Asset/svgviewer-png-output.png';
import icon1 from '../Asset/Vector 7.png';
import arrowBottom from '../Asset/Arrow 6.png';

const ShopOwnerInsuranceFAQ = () => {
  const [faqs] = useState([
    {
      question: "Q1.How do I determine the right amount of coverage for my shop?",
      answer: (
        <>
         To determine the right amount of coverage for your shop, <span style={{ color: "#F37435", fontWeight: "700" }} >add up the value of your inventory and equipment, and consider any improvements you've made. Think about risks like accidents or having to close temporarily. </span>Check local rules and talk to an insurance expert for advice. Regularly review your coverage to keep it up to date as your business grows.

        </>
      )
    },
    {
      question: "Q2.Can I buy one insurance policy to cover all my stores across the city?",
      answer: (
        <>
        <span style={{ color: "#F37435", fontWeight: "700" }} >Yes,</span> you can get a single insurance policy that covers all your stores in different city locations. It's called a multi-location or blanket insurance policy. This way, you manage all your stores' insurance needs with one policy, which can be simpler and more cost-effective than having separate policies for each store.
       </>
      )
    },
    {
      question: "Q3.What happens to my shop insurance if I sell my shop?",
      answer:(
        <>
        If you sell your shop, your shop insurance generally does not transfer to the new owner. You will need to notify your insurance provider about the sale and <span style={{ color: "#F37435", fontWeight: "700" }} >either cancel or adjust your policy accordingly. The insurance company may provide a pro-rated refund for the unused portion of your premium. </span>The new owner will be responsible for obtaining their own shop insurance to cover their operations and protect their investment.
      </>
      )
      },

      {
        question: "Q4.Do I need shop owner insurance if I operate an online store or sell goods from home?",
        answer:(
          <>
         Yes, you may still need shop owner insurance even if you operate an online store or sell goods from home. Here’s why:
         <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>Liability Coverage: </span>Shop owner insurance typically includes liability coverage, which protects you if someone is injured on your property or if your product causes harm to a customer.
         <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>Property Coverage:</span> It can cover your business equipment, inventory, and any improvements to your home or designated workspace against risks like theft, fire, or vandalism.
         <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>Business Interruption: </span>If an unexpected event (like a fire or natural disaster) interrupts your business operations, business interruption insurance included in shop owner policies can help cover lost income and ongoing expenses.
         <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>Legal Protection:</span> It may also provide legal defense if you face a lawsuit related to your business activities.
        </>
        )
        },
    {
      question: "Q5.If my shop is located in a building that is already insured, do I still need separate shop insurance?",
      answer: (
        <>
         Yes, you should still consider getting <span style={{ color: "#F37435", fontWeight: "700" }} >shop insurance even if the building is insured.</span>Building insurance typically covers structural damage and liability related to the building itself, such as fire or structural failures.
         However, shop insurance is important because it covers your business-specific assets and liabilities, such as inventory, equipment, liability for customer injuries, and business interruption. This ensures overall protection tailored to your shop's unique risks and needs, which may not be fully covered by the building's insurance policy.
        </>
      )
    },
    {
      question: "Q6.Is shop owner insurance tax-deductible for my business?",
      answer: (
        <>
          <span style={{ color: "#F37435", fontWeight: "700" }} > Yes, shop owner insurance premiums are generally tax-deductible as a business expense.</span> This includes policies that cover property damage, liability, business interruption, and other relevant risks associated with operating your shop. It's advisable to consult with a tax advisor to understand specific deductions and ensure compliance with tax regulations applicable to your business.
        </>
      )
      
    },
   
    {
      question: "Q7.Can I adjust my shop owner insurance policy if my business expands or changes?",
      answer: (
        <>
         <span style={{ color: "#F37435", fontWeight: "700" }} >Yes,</span> you can change your shop owner insurance as your business grows or changes. Just contact your insurance provider to update your policy based on new activities, locations, or inventory. This keeps your coverage current and tailored to your business needs.
        </>
      )
        
    },
    {
      question: "Q8.What is the difference between replacement cost and actual cash value coverage in shop owner insurance?",
      answer: 
      (
        <>
        <span style={{ color: "#F37435", fontWeight: "700" }} > Replacement Cost Coverage:</span>
        What it does: Pays to replace damaged or stolen items with new ones of similar quality, without accounting for depreciation.
        Example: If your computer is stolen, this coverage would pay for a new computer of the same kind.
        <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>Actual Cash Value (ACV) Coverage:</span>
        What it does: Pays based on the current value of an item, considering depreciation.
        Example: If your stolen computer is 5 years old, ACV coverage would pay you what the computer is worth now, which is less than its original price.
        </>
      )
    },
    {
        question: "Q9.How does the policy handle partial damage or loss?",
        answer: 
        (
          <>
           If only part of your insured property is damaged or lost, the policy covers the cost to repair or replace that specific portion. The reimbursement is based on the extent of the damage compared to the total insured value of the property. Make sure to report any partial damage immediately and provide documentation to ensure your claim is processed smoothly.
          </>
        )
      },
   
  ]);

  const [visible, setVisible] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [selectedFaqIndex, setSelectedFaqIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const faqContainerRef = useRef(null);

 const toggleVisibility = () => {
    if (window.pageYOffset > 100 && !buttonClicked) {
      setVisible(true);
    } else if (window.pageYOffset <= 100) {
      setVisible(false);
      setButtonClicked(false); // Allow the button to reappear once the user scrolls back to the top
    }
  };

  const scrollToTop = (e) => {
    e.preventDefault(); // Prevent the default anchor click behavior
    console.log(visible); // Log current state
    setVisible(false); // Hide the button immediately when clicked
    setButtonClicked(true); // Mark the button as clicked
  };

  useEffect(() => {
    if (!visible && buttonClicked) {
      console.log(visible); // Log updated state
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [visible, buttonClicked]);

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, [buttonClicked]);



  
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

//   const handleFaqClick = (index) => {
//     setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
//   };
const handleFaqClick = (index) => {
    if (isMobile) {
      setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
    } else {
      setSelectedFaqIndex(index);
    }
  };
  const handleClickOutside = (event) => {
    if (faqContainerRef.current && !faqContainerRef.current.contains(event.target)) {
      setSelectedFaqIndex(null);
    }
  };

  useEffect(() => {
    if (isMobile) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobile]);

  return (
    <div>
      <div className='qa-section'>
        <img src={Wave} alt="Wave" className='waveimg' />
        <div ref={faqContainerRef} className={`faq-ct ${isMobile ? 'mobile' : ''}`}>
          <div className="ct box">
            <div className="ct2">
              <h2 style={{ color: "#F37435", fontWeight: "700" }}>FAQ</h2>
              <p style={{ fontSize: "20px", fontWeight: "400", marginTop: '2rem' }}>Frequently Asked Questions</p>
            </div>
            <div className="subct">
              <ul style={{ listStyleType: "none", padding: 0 }}>
                {faqs.map((faq, index) => (
                  <li
                    className={`ct3 ${selectedFaqIndex === index ? "highlighted" : ""} ${isMobile ? "highlighted" : ""}`}
                    key={index}
                    onClick={() => handleFaqClick(index)}
                  >
                    <div className='faq-question'>
                      <strong className='view'>{faq.question}</strong>
                      <img src={icon1} className="side-arrow" alt="sideicon" />
                    </div>
                    {isMobile && (
                      <span className={`arrow ${selectedFaqIndex === index ? "expanded" : ""}`}></span>
                    )}
                    {isMobile && selectedFaqIndex === index && (
                      <div className="subcon1 mobile-subcon">
                        <p>{faq.answer}</p>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {!isMobile && selectedFaqIndex !== null && (
            <div className="con">
              <div className="subcon">
                <p>{faqs[selectedFaqIndex].question}</p>
              </div>
              <div className="subcon1">
                <p>{faqs[selectedFaqIndex].answer}</p>
              </div>
            </div>
          )}
        </div>
        {visible && (
          <a
            href="#"
            id="scroll"
            onClick={scrollToTop}
            // style={styles.scroll}
            
          >
            <img src={arrowBottom} id="arrowsign" alt="Scroll to top"  />
          </a>
        )}
      </div>
    </div>
  );
};

const styles = {
  scroll2: {
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    right: '5%',
    bottom: '10rem',
    // right: '2%',
    // bottom: '1rem',
    cursor: 'pointer',
    width: '71px',
    height: '71px',
    backgroundColor: 'white',
    borderRadius: '60px',
    zIndex: '1000',
    justifyContent: 'center',
    // boxShadow: '0px 10px 26px rgba(0, 109, 141, 0.2)', 
    boxShadow: '0px 1px 16px rgba(0, 109, 141, 0.25)',
  },
 

  
 span: {
    display: 'block'
  }

};



export default ShopOwnerInsuranceFAQ;